import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ZDivider } from '@zanichelli/albe-web-components/react';

import { hideModal } from '../../../../actions/modal';
import Spacer from '../../../spacer';

import Modal from '../..';
import { Content, ModalBodyContainer } from '../../components';
import Buttons from '../../buttons';
import { DividerSize } from '@zanichelli/albe-web-components';

export const Message = styled.span``;

export const Alert = styled.span`
    letter-spacing: 0.16px;
    text-transform: uppercase;
    color: var(--red700);
`;

export const SendGradeErrorModalBody = ({ onClose }) => (
    <Modal title="Impossibile inviare i risultati" onClose={onClose}>
        <ModalBodyContainer>
            <Content>
                <Alert
                    className="body-4-sb"
                    style={{
                        letterSpacing: '0.16px',
                        textTransform: 'uppercase',
                        color: 'var(--red700)',
                    }}
                >
                    {'Non siamo riusciti a inviare i risultati'}
                </Alert>
                <Spacer size="base" />
                <ZDivider size={DividerSize.SMALL} color="gray800" />
                <Spacer size="base" />
                <Message className="body-3">{'Hai bisogno di aiuto? Contattaci dalla pagina dei Risultati.'}</Message>
            </Content>
            <Buttons primaryButtonClick={onClose} primaryButtonText="Guarda i risultati" showTertiaryButton={false} />
        </ModalBodyContainer>
    </Modal>
);

SendGradeErrorModalBody.propTypes = {
    onClose: PropTypes.func,
};

const actionCreator = {
    onClose: hideModal,
};

export default connect(null, actionCreator)(SendGradeErrorModalBody);
